// @ts-nocheck

import { createSelector } from 'reselect';

import { getLang } from '../../../../i18n/l10n';
import { type SelectorMaker, type Selector } from '../../../../types/selectors';
import { BoomAssetsBySkinId } from '../../constants/assets';
import {
  selectBoomGlobalOperationStartDate,
  selectBoomGlobalSkinId,
} from '../../selectors/global/globalPrimary.selector';

type BoomBannerPropsType = {
  backgroundPath: string;
  showCountdown?: boolean;
};

const makeSelectBoomBannerPropsSelector: SelectorMaker<BoomBannerPropsType> = () => {
  const selectBackgroundPath: Selector<string> = createSelector(
    [selectBoomGlobalSkinId],
    (skinId) => BoomAssetsBySkinId[skinId]?.Banners[getLang()],
  );

  return createSelector([selectBackgroundPath, selectBoomGlobalOperationStartDate], (backgroundPath, startDate) => ({
    backgroundPath,
    showCountdown: new Date() >= startDate,
  }));
};

export default makeSelectBoomBannerPropsSelector;
